export const LAYER_STATEMENT = '@layer theme, base, antd, components, utilities;'